import {
  REPLENISHMENTS,
  LOGIN,
  HANDHELD_LINK,
  HANDHELD_LINK_SHORT,
  SSO_CALLBACK,
  ORDERS,
  ROOT,
  ACCESS_DENIED,
  ORDERS_SHIPPED,
  PICK_N_SHIP,
  ORDERS_PROCESSING,
  GENERATE_ORDER_LABEL,
  GENERATE_LABELS,
  GENERATE_SHARED_LABEL,
  SHOW_REPLENISHMENT,
  CLAIMS,
  SHOW_CLAIM,
  RETURNS,
  LOCATIONS,
  WAREHOUSES,
  INVENTORY_HISTORY,
  VIEW_WAREHOUSE_LOCATIONS,
  RECEIVE_RETURN,
  CREATE_RETURN,
  SEARCH_RETURN,
  RECEIVE_RETURNED_ORDER,
  BILLING,
  BILLING_STORE,
  BILLING_STORE_CONFIG_CREATE,
  BILLING_STORE_CONFIG_DUPLICATE,
  WORK_ORDERS,
  SHOW_WORK_ORDER,
  REASSING_CARRIER,
  SHOW_REPLENISHMENT_BOXES,
  INBOUND_APPOINTMENTS,
  C2C_RECEIVING,
  PENDING_PRINTS,
  NATURA_REPLENISHMENTS,
  PICKING_PRODUCTIVITIES,
  PICKING_TASKS_TO_BREAK,
  ESTAFETA_ADDRESS_CORRECTOR,
  CONFIGURATIONS,
  CONFIGURATIONS_COBERTURAS_EDIT_BY_RANGE,
  CONFIGURATIONS_COBERTURAS_EDIT_ALL,
  CONFIGURATIONS_COBERTURAS_BULK_MANAGE,
  CONFIGURATIONS_COBERTURAS_MANAGE,
  CONFIGURATIONS_COBERTURAS,
  CONFIGURATIONS_OPERATORS,
  CONFIGURATIONS_CAIXAS,
  CONFIGURATIONS_STORE_BOXES,
  CONFIGURATIONS_CONTAINER_TEMPLATES,
  CONFIGURATIONS_CONTAINER_TEMPLATE_EDITOR,
  CONFIGURATIONS_CONTAINER_TEMPLATE_CREATE,
  CONFIGURATIONS_BARCODE_POOL,
  CONFIGURATIONS_SALES_CHANNELS,
  CONFIGURATIONS_CAMPAIGNS,
  CONFIGURATIONS_RECEIVING_CAPACITY_OVERRIDES,
  CONFIGURATIONS_RECEIVING,
  CONFIGURATIONS_RECEIVING_SETTINGS,
  CONFIGURATIONS_RECEIVING_OVERRIDES,
  CONFIGURATIONS_RECEIVING_HISTORY,
  CONFIGURATIONS_PACKING,
  CONFIGURATIONS_DISPATCH_RECIPIENTS,
  DELETE_LOST_STOCK,
  DELETED_LOST_HISTORY,
  SHIPPING_PACKAGES,
  LASTMILE_SHIPPING_METHODS,
  LASTMILE_SHIPPING_METHOD_COVERAGES,
  LASTMILE_SHIPPING_METHOD_COVERAGES_BY_RANGE,
  LASTMILE_SHIPPING_METHOD_COVERAGES_ALL,
  LASTMILE_SHIPPING_METHOD_COVERAGES_BULK_MANAGE,
  DISPATCH_SCHEDULES,
  ROMANEIOS,
  PROOF_VIDEO_COVERAGE,
  PROOF_VIDEO_COVERAGE_PERMISSION,
  AUTOMATED_COVERAGE_DEACTIVATIONS,
  CYCLE_COUNTS,
  FULFILLMENT_ERRORS,
  FULFILLMENT_ERROR_ORDER_DETAIL,
  FOUND_STOCK,
  SELECT_WAREHOUSE,
  WORKFORCE,
  WORKFORCE_RATES,
  WORKFORCE_COSTS,
  WORKFORCE_SHIFTS,
  WORKFORCE_OPERATORS,
  WORKFORCE_ATTENDANCE,
  WORKFORCE_SCHEDULE,
  UBER_BATCHES,
  UBER_BATCH_DETAIL,
  BOX_PACKING_PREVIEW,
  MULTI_BOX_PACKING_PREVIEW,
  NATURA_OPS_CREATE_ORDER,
  NATURA_OPS_PICKING,
  NATURA_OPS_NOTA_FISCAL,
  NATURA_OPS_DEPOSIT_TRANSFER,
  NATURA_OPS_CONFIRMATION_RESEND,
  NATURA_OPS_NOTFIS_UPLOAD,
} from './constants'
import { Switch, Redirect } from 'react-router-dom'
import { Home } from '../pages/Home'
import { AccessDenied } from '../pages/Errors'
import { Layout1 } from '../components'
import { Login } from '../pages/Login'
import SsoCallback from '../pages/Login/SsoCallback'
import { ListActiveReplenishments, ShowReplenishment } from '../pages/Replenishments'
import { InboundAppointmentsBoardContainer } from '../pages/InboundAppointments'
import { C2cReceivingContainer } from '../pages/C2cReceiving'
import { PendingPrintsContainer } from '../pages/PendingPrints'
import { ProofVideoCoverageContainer } from '../pages/ProofVideoCoverage'
import { ReplenishmentForm } from '../pages/ReplenishmentsNatura'
import { ShowReplenishmentBoxes } from '../pages/ReplenishmentBoxes'
import { ListOrderContainer, PickAndShipContainer } from '../pages/Orders'
import { ListOrdersShippedContainer } from '../pages/Orders'
import { ListOrdersReverseLogisticsContainer } from '../pages/Orders'
import { GenerateShipment } from '../pages/Orders/GenerateShipment/GenerateShipment'
import { GenerateShipmentView } from '../pages/Orders/GenerateShipment/GenerateShipmentView'
import { BoxPackingPreview } from '../pages/_Sandbox/BoxPackingPreview'
import { MultiBoxPackingPreview } from '../pages/_Sandbox/MultiBoxPackingPreview'
import { ListProcessingOrders } from '../pages/Orders'
import PublicRoute from './Auth/PublicRoute'
import PrivateRoute from './Auth/PrivateRoute'
import { ListClaimsContainer } from '../pages/Claims/ListClaimsContainer'
import { ClaimDetailContainer } from '../pages/Claims/ClaimDetailContainer'
import { ListReturnContainer } from '../pages/Returns/ListReturnContainer'
import { ListProductsContainer } from '../pages/Inventory/ListProductsContainer'
import { ListWarehousesContainer } from '../pages/Warehouses/ListWarehousesContainer'
import { ReassingCarrier } from '../pages/Orders/ReassingCarrier/ReassingCarrier'
import { ListLocationsContainer } from '../pages/Locations/ListLocationsContainer'
import { ViewWarehouseLocationsContainer } from '../pages/Locations/ViewWarehouseLocationsContainer'
import { ListInventoryHistoryContainer } from '../pages/InventoryHistory/ListInventoryHistoryContainer'
import { GenerateSharedLabel } from '../pages/Orders/GenerateShipment/GenerateSharedLabel'
import { ReceiveReturnContainer } from '../pages/Returns/ReceiveReturnContainer'
import { SearchReturnContainer } from '../pages/Returns/SearchReturnContainer'
import { ListBillingStoresContainer } from '../pages/Billing/ListBillingStoresContainer'
import { BillingStoreConfigTabs } from '../pages/Billing/BillingStoreConfigTabs'
import { ListWorkOrdersContainer } from '../pages/WorkOrders/ListWorkOrdersContainer'
import { WorkOrderDetailContainer } from '../pages/WorkOrders/WorkOrderDetailContainer'
import { PickingProductivitiesContainer } from '../pages/PickingProductivities'
import { PickingTasksToBreakContainer } from '../pages/PickingTasksToBreak'
import { EstafetaAddressCorrectorContainer } from '../pages/Orders/EstafetaAddressCorrector'
import { DeleteLostStockContainer, DeletedLostHistoryContainer } from '../pages/DeleteLostStock'
import { ListShippingPackagesContainer } from '../pages/ShippingPackages'
import { StoreAllowedShippingPackagesContainer } from '../pages/Configurations/StoreAllowedShippingPackages'
import { ListShippingMethodsContainer } from '../pages/CubboLastmile/ShippingMethods'
import { ListDispatchSchedulesContainer } from '../pages/CubboLastmile/DispatchSchedules'
import { ListRomaneiosContainer } from '../pages/Romaneios/ListRomaneiosContainer'
import { ListAutomatedCoverageDeactivationsContainer } from '../pages/CubboLastmile/AutomatedCoverageDeactivations'
import { ListCycleCountsContainer } from '../pages/CycleCounts/ListCycleCountsContainer'
import { ListFulfillmentErrorsContainer } from '../pages/Orders/ListFulfillmentErrorsContainer'
import { FoundStockContainer } from '../pages/FoundStock'
import { ShippingMethodCoverageManagerContainer } from '../pages/CubboLastmile/ShippingMethods/ShippingMethodCoverageManagerContainer'
import { TemplatesListContainer } from '../pages/Configurations/ContainerTemplates/TemplatesListContainer'
import { TemplateEditorContainer } from '../pages/Configurations/ContainerTemplates/TemplateEditorContainer'
import { BarcodePoolContainer } from '../pages/Configurations/BarcodePool/BarcodePoolContainer'
import { ListSalesChannelsContainer } from '../pages/Configurations/SalesChannels'
import { CampaignsContainer } from '../pages/Configurations/Campaigns'
import { ListReceivingCapacityOverridesContainer } from '../pages/Configurations/ReceivingCapacityOverrides'
import { ReceivingSettingsContainer, ReceivingHistoryContainer } from '../pages/Configurations/Receiving'
import { PackingSettingsContainer } from '../pages/Configurations/Packing'
import { DispatchDocumentRecipientsContainer } from '../pages/Configurations/DispatchDocumentRecipients'
import { ListOperatorsContainer } from '../pages/Operators/ListOperatorsContainer'
import { SelectWarehouse } from '../pages/SelectWarehouse/SelectWarehouse'
import { HandheldLinkContainer } from '../pages/HandheldLink/HandheldLinkContainer'
import {
  OperatorRatesContainer,
  OperatorCostsContainer,
  WorkShiftsContainer,
  WarehouseOperatorsContainer,
  AttendanceContainer,
  WorkforceIndexRedirect,
  ShiftScheduleContainer,
} from '../pages/Workforce'
import { UberBatchesList, UberBatchDetail } from '../pages/UberBatches'
import CreateOrderPage from '../pages/NaturaOperations/CreateOrder'
import PickingPage from '../pages/NaturaOperations/Picking'
import NotaFiscalPage from '../pages/NaturaOperations/NotaFiscal'
import DepositTransferPage from '../pages/NaturaOperations/DepositTransfer'
import ConfirmationResendPage from '../pages/NaturaOperations/ConfirmationResend'
import NotfisUploadPage from '../pages/NaturaOperations/NotfisUpload'
import { isProductionEnvironment } from '../helpers/environmentHelper'

export const RouterConfig = () => {
  return (
    <>
      <Switch>
        <PublicRoute exact path={LOGIN} component={Login} />
        <PublicRoute exact path={SSO_CALLBACK} component={SsoCallback} />
        <PrivateRoute exact path={SELECT_WAREHOUSE} component={SelectWarehouse} />
        {/* Self-service HandHeld linking: any authenticated user, no warehouse
                    scoping and no permission gating — reached via QR/link deep-link,
                    not through the sidebar. */}
        <PrivateRoute exact path={HANDHELD_LINK} permission_key={null} component={HandheldLinkContainer} />
        {/* Same container on the short alias rather than a redirect, so the
                    ?next= login round-trip keeps working with no extra hop. */}
        <PrivateRoute exact path={HANDHELD_LINK_SHORT} permission_key={null} component={HandheldLinkContainer} />

        <Layout1>
          <Switch>
            <PrivateRoute exact path={BILLING_STORE_CONFIG_CREATE} component={BillingStoreConfigTabs} />
            <PrivateRoute exact path={BILLING_STORE_CONFIG_DUPLICATE} component={BillingStoreConfigTabs} />
            <PrivateRoute path={BILLING} component={ListBillingStoresContainer} />
            <PrivateRoute exact path={WAREHOUSES} component={ListWarehousesContainer} />
            <PrivateRoute exact path={ROOT} component={Home} />
            <PrivateRoute exact path={ACCESS_DENIED} component={AccessDenied} />
            {/* <PrivateRoute path={INVENTORY}>
                            <ListProductsContainer />
                        </PrivateRoute> */}
            <PrivateRoute path={VIEW_WAREHOUSE_LOCATIONS}>
              <ViewWarehouseLocationsContainer />
            </PrivateRoute>
            <PrivateRoute path={LOCATIONS}>
              <ListLocationsContainer />
            </PrivateRoute>
            <PrivateRoute path={PICK_N_SHIP}>
              <PickAndShipContainer />
            </PrivateRoute>
            <PrivateRoute path={PICKING_PRODUCTIVITIES}>
              <PickingProductivitiesContainer />
            </PrivateRoute>
            <PrivateRoute path={PICKING_TASKS_TO_BREAK} permission_key="resolve_container_breaks">
              <PickingTasksToBreakContainer />
            </PrivateRoute>
            <PrivateRoute path={ORDERS}>
              <ListOrderContainer />
            </PrivateRoute>
            <PrivateRoute path={ORDERS_PROCESSING}>
              <ListProcessingOrders />
            </PrivateRoute>
            <PrivateRoute path={GENERATE_ORDER_LABEL}>
              <GenerateShipment />
            </PrivateRoute>
            <PrivateRoute path={GENERATE_LABELS}>
              <GenerateShipmentView />
            </PrivateRoute>
            {/* Sandbox preview routes — dev/staging only. Mounting in
                            production would expose unfinished UI with mock data
                            to operators and external store users. */}
            {!isProductionEnvironment && <PrivateRoute path={BOX_PACKING_PREVIEW} permission_key={null} component={BoxPackingPreview} />}
            {!isProductionEnvironment && <PrivateRoute path={MULTI_BOX_PACKING_PREVIEW} permission_key={null} component={MultiBoxPackingPreview} />}
            <PrivateRoute path={CREATE_RETURN}>
              <ReceiveReturnContainer />
            </PrivateRoute>
            <PrivateRoute path={SEARCH_RETURN}>
              <SearchReturnContainer />
            </PrivateRoute>
            <PrivateRoute path={RECEIVE_RETURNED_ORDER}>
              <SearchReturnContainer />
            </PrivateRoute>
            <PrivateRoute path={ORDERS_SHIPPED}>
              <ListOrdersShippedContainer />
            </PrivateRoute>
            <PrivateRoute path={ESTAFETA_ADDRESS_CORRECTOR}>
              <EstafetaAddressCorrectorContainer />
            </PrivateRoute>
            <PrivateRoute exact path={SHOW_REPLENISHMENT_BOXES}>
              <ShowReplenishmentBoxes />
            </PrivateRoute>
            <PrivateRoute exact path={INBOUND_APPOINTMENTS} permission_key="complete_replenishment">
              <InboundAppointmentsBoardContainer />
            </PrivateRoute>
            <PrivateRoute exact path={C2C_RECEIVING} permission_key="c2c_receiving_read">
              <C2cReceivingContainer />
            </PrivateRoute>
            <PrivateRoute exact path={PENDING_PRINTS} permission_key={null}>
              <PendingPrintsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={PROOF_VIDEO_COVERAGE} permission_key={PROOF_VIDEO_COVERAGE_PERMISSION}>
              <ProofVideoCoverageContainer />
            </PrivateRoute>
            <PrivateRoute exact path={REPLENISHMENTS}>
              <ListActiveReplenishments />
            </PrivateRoute>
            <PrivateRoute exact path={SHOW_REPLENISHMENT}>
              <ShowReplenishment />
            </PrivateRoute>
            <PrivateRoute path={SHOW_CLAIM}>
              <ClaimDetailContainer />
            </PrivateRoute>
            <PrivateRoute path={CLAIMS}>
              <ListClaimsContainer />
            </PrivateRoute>
            <PrivateRoute path={SHOW_WORK_ORDER}>
              <WorkOrderDetailContainer />
            </PrivateRoute>
            <PrivateRoute path={WORK_ORDERS}>
              <ListWorkOrdersContainer />
            </PrivateRoute>
            <PrivateRoute path={RECEIVE_RETURN}>
              <ReceiveReturnContainer />
            </PrivateRoute>
            <PrivateRoute path={RETURNS}>
              <ListReturnContainer />
            </PrivateRoute>
            <PrivateRoute path={DELETED_LOST_HISTORY}>
              <DeletedLostHistoryContainer />
            </PrivateRoute>
            <PrivateRoute path={DELETE_LOST_STOCK}>
              <DeleteLostStockContainer />
            </PrivateRoute>
            <PrivateRoute path={INVENTORY_HISTORY}>
              <ListInventoryHistoryContainer />
            </PrivateRoute>
            <PrivateRoute path={GENERATE_SHARED_LABEL}>
              <GenerateSharedLabel />
            </PrivateRoute>
            <PrivateRoute path={REASSING_CARRIER}>
              <ReassingCarrier />
            </PrivateRoute>
            <PrivateRoute path={NATURA_REPLENISHMENTS}>
              <ReplenishmentForm />
            </PrivateRoute>
            <PrivateRoute exact path={NATURA_OPS_CREATE_ORDER} permission_key="natura_manaus_poa_ops" component={CreateOrderPage} />
            <PrivateRoute exact path={NATURA_OPS_PICKING} permission_key="natura_manaus_poa_ops" component={PickingPage} />
            <PrivateRoute exact path={NATURA_OPS_NOTA_FISCAL} permission_key="natura_manaus_poa_ops" component={NotaFiscalPage} />
            <PrivateRoute exact path={NATURA_OPS_DEPOSIT_TRANSFER} permission_key="natura_manaus_poa_ops" component={DepositTransferPage} />
            <PrivateRoute exact path={NATURA_OPS_CONFIRMATION_RESEND} permission_key="natura_manaus_poa_ops" component={ConfirmationResendPage} />
            <PrivateRoute exact path={NATURA_OPS_NOTFIS_UPLOAD} permission_key="natura_manaus_poa_ops" component={NotfisUploadPage} />
            <PrivateRoute path={SHIPPING_PACKAGES}>
              <ListShippingPackagesContainer />
            </PrivateRoute>
            <PrivateRoute
              exact
              path={[LASTMILE_SHIPPING_METHOD_COVERAGES_BY_RANGE, LASTMILE_SHIPPING_METHOD_COVERAGES_ALL, LASTMILE_SHIPPING_METHOD_COVERAGES_BULK_MANAGE]}
              component={({ match }) => (
                <Redirect
                  to={LASTMILE_SHIPPING_METHOD_COVERAGES.replace(':warehouse_id', match.params.warehouse_id).replace(
                    ':shipping_method_id',
                    match.params.shipping_method_id,
                  )}
                />
              )}
            />
            <PrivateRoute exact path={LASTMILE_SHIPPING_METHOD_COVERAGES}>
              <ShippingMethodCoverageManagerContainer />
            </PrivateRoute>
            <PrivateRoute exact path={LASTMILE_SHIPPING_METHODS}>
              <ListShippingMethodsContainer />
            </PrivateRoute>
            <PrivateRoute path={DISPATCH_SCHEDULES}>
              <ListDispatchSchedulesContainer />
            </PrivateRoute>
            <PrivateRoute path={ROMANEIOS}>
              <ListRomaneiosContainer />
            </PrivateRoute>
            <PrivateRoute path={AUTOMATED_COVERAGE_DEACTIVATIONS}>
              <ListAutomatedCoverageDeactivationsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={UBER_BATCH_DETAIL}>
              <UberBatchDetail />
            </PrivateRoute>
            <PrivateRoute exact path={UBER_BATCHES}>
              <UberBatchesList />
            </PrivateRoute>
            <PrivateRoute exact path={CYCLE_COUNTS} component={ListCycleCountsContainer} />
            <PrivateRoute exact path={FULFILLMENT_ERRORS} component={ListFulfillmentErrorsContainer} />
            <PrivateRoute exact path={FULFILLMENT_ERROR_ORDER_DETAIL} component={ListFulfillmentErrorsContainer} />
            <PrivateRoute exact path={FOUND_STOCK} component={FoundStockContainer} />
            {/* Deprecated /configurations/coverages/* URLs redirect to the lastmile coverages screens.
                            permission_key={null} opts these routes out of the /configurations nav-table access
                            gate (the legacy "coverages" sub-item is gone); the destination routes enforce access. */}
            <PrivateRoute
              exact
              permission_key={null}
              path={[CONFIGURATIONS_COBERTURAS_EDIT_BY_RANGE, CONFIGURATIONS_COBERTURAS_EDIT_ALL, CONFIGURATIONS_COBERTURAS_BULK_MANAGE]}
              component={({ match }) => (
                <Redirect
                  to={LASTMILE_SHIPPING_METHOD_COVERAGES.replace(':warehouse_id', match.params.warehouse_id).replace(
                    ':shipping_method_id',
                    match.params.shipping_method_id,
                  )}
                />
              )}
            />
            <PrivateRoute
              exact
              permission_key={null}
              path={[CONFIGURATIONS_COBERTURAS_MANAGE, CONFIGURATIONS_COBERTURAS]}
              component={({ match }) => <Redirect to={LASTMILE_SHIPPING_METHODS.replace(':warehouse_id', match.params.warehouse_id)} />}
            />
            <PrivateRoute path={CONFIGURATIONS_OPERATORS}>
              <ListOperatorsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_CAIXAS}>
              <ListShippingPackagesContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_STORE_BOXES}>
              <StoreAllowedShippingPackagesContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_CONTAINER_TEMPLATE_CREATE}>
              <TemplateEditorContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_CONTAINER_TEMPLATE_EDITOR}>
              <TemplateEditorContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_CONTAINER_TEMPLATES}>
              <TemplatesListContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_BARCODE_POOL}>
              <BarcodePoolContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_SALES_CHANNELS}>
              <ListSalesChannelsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_CAMPAIGNS}>
              <CampaignsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_RECEIVING_SETTINGS}>
              <ReceivingSettingsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_RECEIVING_OVERRIDES}>
              <ListReceivingCapacityOverridesContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_RECEIVING_HISTORY}>
              <ReceivingHistoryContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_PACKING}>
              <PackingSettingsContainer />
            </PrivateRoute>
            <PrivateRoute exact path={CONFIGURATIONS_DISPATCH_RECIPIENTS}>
              <DispatchDocumentRecipientsContainer />
            </PrivateRoute>
            <PrivateRoute
              exact
              path={CONFIGURATIONS_RECEIVING}
              component={({ match }) => <Redirect to={CONFIGURATIONS_RECEIVING_SETTINGS.replace(':warehouse_id', match.params.warehouse_id)} />}
            />
            {/* Deprecated /configurations/receiving-capacity-overrides URL redirects to the Receiving
                            overrides tab. permission_key={null} opts this route out of the /configurations
                            nav-table access gate (the legacy sub-item is gone); the destination route enforces access. */}
            <PrivateRoute
              exact
              path={CONFIGURATIONS_RECEIVING_CAPACITY_OVERRIDES}
              permission_key={null}
              component={({ match }) => <Redirect to={CONFIGURATIONS_RECEIVING_OVERRIDES.replace(':warehouse_id', match.params.warehouse_id)} />}
            />
            <PrivateRoute
              exact
              path={CONFIGURATIONS}
              component={({ match }) => <Redirect to={CONFIGURATIONS_OPERATORS.replace(':warehouse_id', match.params.warehouse_id)} />}
            />
            <PrivateRoute exact path={WORKFORCE_RATES} permission_key="manage_operator_rates" component={OperatorRatesContainer} />
            <PrivateRoute exact path={WORKFORCE_COSTS} permission_key="index_operator_costs" component={OperatorCostsContainer} />
            <PrivateRoute exact path={WORKFORCE_SHIFTS} permission_key="manage_workforce_shifts" component={WorkShiftsContainer} />
            <PrivateRoute exact path={WORKFORCE_SCHEDULE} permission_key="manage_workforce_shifts" component={ShiftScheduleContainer} />
            <PrivateRoute exact path={WORKFORCE_OPERATORS} permission_key="manage_warehouse_operators" component={WarehouseOperatorsContainer} />
            <PrivateRoute exact path={WORKFORCE_ATTENDANCE} permission_key="mark_attendance" component={AttendanceContainer} />
            <PrivateRoute exact path={WORKFORCE} permission_key={null} component={WorkforceIndexRedirect} />
            <PrivateRoute path={WAREHOUSES}>
              <ListWarehousesContainer />
            </PrivateRoute>
          </Switch>
        </Layout1>
      </Switch>
    </>
  )
}
